<app-job-notification-card
  (closeEvent)="onCloseClickedHandler()"
  [jobNotification]="journalNotificationCard"
  [notificationIcon]="journalNotificationCard.journalFileType === journalFileTypePdf ? 'svg_pdf_multiple' : 'svg_excel'"
>
  <div notification-action-button>
    <app-print-action-buttons
      (downloadFecButtonClickedEvent)="downloadJournalFecButtonClickedHandler()"
      (downloadPdfButtonClickedEvent)="downloadJournalPdfButtonClickedHandler()"
      (downloadSpreadsheetButtonClickedEvent)="downloadJournalSpreadsheetButtonClickedHandler()"
      (openPdfButtonClickedEvent)="openJournalPdfButtonClickedHandler()"
      [downloadFecFlag]="journalNotificationCard.journalFileType === journalFileTypeFec"
      [downloadPdfFlag]="journalNotificationCard.journalFileType === journalFileTypePdf"
      [downloadSpreadsheetFlag]="journalNotificationCard.journalFileType === journalFileTypeSpreadsheet"
      [openPdfFlag]="journalNotificationCard.journalFileType === journalFileTypePdf"
      class="floating-action-buttons"
    ></app-print-action-buttons>
  </div>
</app-job-notification-card>
